module.exports = __webpack_public_path__ + "media/images/competitions/requirements_bg_blur-bd5406fe42ac31cb6c9c45205bf9c95a.jpg";